export enum OBJECT_TYPES {
	block = 'block',
	inline = 'inline',
	text = 'text',
	mark = 'mark',
}

export enum BLOCK_TYPES {
	p = 'paragraph',
	h1 = 'heading1',
	h2 = 'heading2',
	h3 = 'heading3',
	h4 = 'heading4',
	h5 = 'heading5',
	h6 = 'heading6',
	ul = 'unordered_list',
	ol = 'ordered_list',
	li = 'list_item',
	section = 'section',
	aside = 'aside',
}

export enum INLINE_TYPES {
	a = 'link',
}

export enum STYLE_TYPES {
	UNEDITABLE_STYLES = 'uneditableStyles',
	FONT_SIZE = 'font-size',
	FONT_FAMILY = 'font-family',
	FONT_WEIGHT = 'font-weight',
	FONT_STYLE = 'font-style',
	COLOR = 'color',
	TEXT_DECORATION = 'text-decoration',
	TEXT_TRANSFORM = 'text-transform',
	LETTER_SPACING = 'letter-spacing',
	TEXT_SCRIPT = 'textScript', // sub or super script
	EMPTY = 'empty', // for keeping empty inner <span> elements added by inDesign
}

// We have to keep order of marks for proper display of formatted text (for example, color of underline)
export const MARK_TYPES = [
	STYLE_TYPES.UNEDITABLE_STYLES,
	STYLE_TYPES.FONT_SIZE,
	STYLE_TYPES.FONT_FAMILY,
	STYLE_TYPES.FONT_WEIGHT,
	STYLE_TYPES.FONT_STYLE,
	STYLE_TYPES.COLOR,
	STYLE_TYPES.TEXT_DECORATION,
	STYLE_TYPES.TEXT_TRANSFORM,
	STYLE_TYPES.LETTER_SPACING,
	STYLE_TYPES.TEXT_SCRIPT,
	STYLE_TYPES.EMPTY,
];

export enum MARK_TAGS {
	span = 'span',
}

export enum TEXT_ALIGN {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
	JUSTIFY = 'justify',
}

export enum TEXT_DECORATION {
	NONE = 'none',
	UNDERLINE = 'underline',
	LINE_THROUGH = 'line-through',
}

export enum TEXT_TRANSFORM {
	NONE = 'none',
	CAPITALIZE = 'capitalize',
	LOWERCASE = 'lowercase',
	UPPERCASE = 'uppercase',
}

export enum LIST_TYPE {
	ORDERED = 'ordered',
	UNORDERED = 'unordered',
	NONE = 'none',
}

export enum TEXT_SCRIPT {
	SUB = 'sub',
	SUPER = 'super',
}

export const BLOCK_AND_INLINE_TAGS = {
	p: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.p,
	},
	h1: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h1,
	},
	h2: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h2,
	},
	h3: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h3,
	},
	h4: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h4,
	},
	h5: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h5,
	},
	h6: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h6,
	},
	ul: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.ul,
	},
	ol: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.ol,
	},
	li: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.li,
	},
	a: {
		object: OBJECT_TYPES.inline,
		type: INLINE_TYPES.a,
	},
	section: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.section,
	},
	aside: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.aside,
	},
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/constants.ts